import React, {Component} from 'react';
import {Link, Redirect} from 'react-router-dom'
import Input from './components/Input';
import Button from './components/Button'
import fetchWP from './utils/fetchWP';
import Select from 'react-select';
import moment from 'moment';
import AsyncSelect from 'react-select/lib/Async';
import Modal from 'react-modal';
//Custom Components 
import TaxonomyGroup from './components/TaxonomyGroup'

// const products = window.awdp_object.products;
const options = [];
// if (products) {
//     for (var i = 0; i < products.length; i++) {
//         options.push({ value: products[i]['ID'], label: products[i]['post_title'], photo: products[i]['post_thumbnail'] })
//     }
// }
let productList = [];
let productListDefault = [];
const productCategory = window.awdp_object.cats;
const categories = [];
if (productCategory) {
    for (var id in productCategory) {
        categories.push({label: productCategory[id], value: id})
    }
}
const filterProduct = (inputValue) => {

    return productList.filter(i =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
};
const ProductListType = [
    {value: 'products_selection', label: 'Products Selection'},
    {value: 'dynamic_request', label: 'Dynamic Request'}
];
const productOptions = inputValue =>
    new Promise(resolve => {
        resolve(filterProduct(inputValue));
        // setTimeout(() => {
        //     resolve(filterProduct(inputValue));
        // }, 100);
    });

const authorslist = window.awdp_object.userlists;
const authors = [];
if (authorslist) {
    for (var i = 0; i < authorslist.length; i++) {
        authors.push({label: authorslist[i]['display_name'], value: authorslist[i]['id']})
    }
}
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

function renderFriend(option) {
    return (<span><img width="30" height="30" src={option.photo}/><span>{option.name}</span></span>);
}

export default class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'action': this.props.match.params.id == 'add' ? 'add' : 'update',
            'redirect': false,
            modalIsOpen: false,
            isHidden: true,
            awdpLoader: true,
            dynamicrequest: false,
            productList: [],
            rule: {
                id: false,
                name: '',
                list_type: '',
                selectedProducts: [],
                excludedProducts: [],
                rules: []
            }
        }
        this.fetchWP = new fetchWP({
            restURL: window.awdp_object.root,
            restNonce: window.awdp_object.api_nonce,
        });

        // this.handleTextArea = this.handleTextArea.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleExcludeChange = this.handleExcludeChange.bind(this);
        this.handleTaxRelation = this.handleTaxRelation.bind(this);
        this.handleFormDeletion = this.handleFormDeletion.bind(this);
        this.handleAuthorChange = this.handleAuthorChange.bind(this);
        this.handleProductChange = this.handleProductChange.bind(this);
        this.handleExcludeChange = this.handleExcludeChange.bind(this);

        //Model
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        updateDisabled: false;
        deleteDisabled: false;
        noDisabled: false;
        yesDisabled: false;


    }

    /* This lifecycle hook gets executed when the component mounts */
    openModal() {
        this.setState({modalIsOpen: true});
    }

    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id != prevProps.match.params.id) {
            if (this.props.match.params.id == 'add') {
                this.setState({
                    awdpLoader: false,
                    rule: {
                        name: '',
                        id: false,
                        list_type: '',
                        selectedProducts: [],
                        productAuthor: '',
                        excludedProducts: [],
                        taxRelation: null,
                        rules: []
                    }
                });
            } else {
                this.fetchRule();
            }

        }
    }

    fetchRule() {
        this.setState({
            awdpLoader: true,
        });
        this.fetchWP.get('productlist/' + this.props.match.params.id)
            .then(
                (json) => {
                    productListDefault = json.defaultProducts;
                    productList = productList.length == 0 ? productListDefault : productList;
                    this.setState(prevState => (
                        {
                            rule: {
                                ...prevState.rule,
                                name: json.list_name,
                                id: json.list_id,
                                list_type: json.list_type,
                                selectedProducts: json.selectedProducts,
                                productAuthor: json.productAuthor,
                                excludedProducts: json.excludedProducts,
                                taxRelation: json.taxRelation,
                                rules: json.rules != '' ? json.rules : []
                            },
                            awdpLoader: false,
                            dynamicrequest: json.list_type != null ? json.list_type == 'dynamic_request' ? true : false : ''
                        }
                    ), () => {
                        // console.log(json.selectedProducts)
                    })
                }
            );
    }


    componentDidMount() {
        let title = 'Edit rule';

        this.fetchWP.get('data/products/')
            .then(
                (json) => {
                    productList = json;
                    // this.setState(prevState => (
                    //     {
                    //         productList:{...prevState.productList,json}
                    //     }
                    // ),()=>{
                    //
                    // })
                }
            );
        if (this.props.match.params.id == 'add') {
            title = 'Add New';
            this.setState({
                awdpLoader: false,
                rule: {
                    name: '',
                    id: false,
                    list_type: '',
                    selectedProducts: [],
                    productAuthor: '',
                    excludedProducts: [],
                    taxRelation: null,
                    rules: []
                }
            });
        } else {
            this.fetchRule();
        }
    }

    handleInput(e) {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, [name]: value
            }
        }))
    }

    handleTypeChange(data) {
        let value = data.value;
        if (value == 'dynamic_request') {
            this.setState({
                dynamicrequest: true
            });
        } else {
            this.setState({
                dynamicrequest: false
            });
        }
        // console.log(this.state.rule.list_type)
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, list_type: value
            }
        }))

    }

    handleAuthorChange(data) {
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, productAuthor: data
            }
        }));
    }

    handleExcludeChange(data) {
        let values = data.map(e => e.value);
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, excludedProducts: values
            }
        }));
    }

    handleTaxRelation(data) {
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, taxRelation: data.value
            }
        }));
    }

    handleProductChange(data) {
        let values = data.map(e => e.value);
        // console.log(values);
        this.setState(prevState => ({
            rule: {
                ...prevState.rule, selectedProducts: values
            }
        }));
    }

    handleRuleChange(data) {
        // console.log(data);
        this.setState((prevState) => ({
            rule: {...prevState.rule, rules: data}
        }))
    }

    handleFormSubmit(e) {
        e.preventDefault();
        if (this.state.action == 'add') {
            this.createRule();
        } else {
            this.updateRule();
        }
    }

    handleFormDeletion(e) {
        e.preventDefault();
        let ruleData = {'id': this.state.rule.id};
        this.setState({
            noDisabled: true
        });
        this.setState({
            yesDisabled: true
        });
        this.fetchWP.post('delete', ruleData)
            .then(
                (json) => {
                    window.location = json;
                    this.setState({
                        noDisabled: false,
                        yesDisabled: false
                    });
                }
            );
    }

    createRule() {
        let ruleData = this.state.rule;
        ruleData.model = this.state.model;
        this.setState({
            isHidden: false
        });
        this.fetchWP.post('product_rule', ruleData)
            .then(
                (json) => {
                    this.setState(prevState => ({
                        redirect: true,
                        isHidden: true,
                        rule: {...prevState.rule, id: json}
                    }))
                }
            );
    }

    updateRule() {
        let ruleData = this.state.rule;

        this.setState({
            isHidden: false,
            updateDisabled: true,
            deleteDisabled: true
        });

        this.fetchWP.post('product_rule', ruleData)
            .then(
                (json) => {
                    this.setState({
                        isHidden: true,
                        updateDisabled: false,
                        deleteDisabled: false
                    });
                }
            );
    }

    render() {

        const buttonStyle = {
            margin: '10px 10px 10px 10px'
        }
        const hideButton = {
            display: 'none'
        }
        const AWRPLoader = () => (
            <div className="awdp_loader"></div>
        ); 
        const {selectedProducts} = this.state;
        return (
            <div className="awdp_detail awdp_pl_detail" ref={input => this.inputElement = input}>
                {this.state.awdpLoader != false ?
                    <div className="awdp_loader"></div>
                : ''}
                {this.state.redirect ? <Redirect to={'/list/' + this.state.rule.id}/> : ''}
                <div className="awdp_produc_detail awdp_padding product_detail_bg_listing">
                    <div className="awdp_field_group">
                        <Input inputType={'text'}
                               title={'List Name'}
                               name={'name'}
                               value={this.state.rule.name}
                               placeholder={'Enter rule name'}
                               handleChange={this.handleInput}/>
                        <div className="form-group">
                            <label className="form-label">Type </label>
                            <Select
                                value={ProductListType.filter(e => e.value == this.state.rule.list_type)}
                                name={'list_type'}
                                onChange={this.handleTypeChange}
                                options={ProductListType}/>
                        </div>

                        {this.state.dynamicrequest == true ? // if dynamic request
                            <div className="awdp_dynamicRequest">
                                <div className="form-group">
                                    <label className="form-label">Taxonomy Relation</label>
                                    <Select
                                        value={[
                                            {value: 'and', label: 'AND'},
                                            {value: 'or', label: 'OR'}
                                        ].filter(e => e.value == this.state.rule.taxRelation)}
                                        name={'taxRelation'}
                                        onChange={this.handleTaxRelation}
                                        options={[
                                            {value: 'and', label: 'AND'},
                                            {value: 'or', label: 'OR'}
                                        ]}/>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Taxonomies</label>
                                    <TaxonomyGroup rules={this.state.rule.rules}
                                        onChange={(data) => {
                                            this.handleRuleChange(data);
                                        }}/>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">Exclude Productss</label>
                                    <div className="awdp_repeat_item">
                                        <AsyncSelect
                                            value={productList.filter(e => Array.isArray(this.state.rule.excludedProducts) ? this.state.rule.excludedProducts.indexOf(e.value) >= 0 : false)}
                                            name={'excludedProducts'}
                                            isMulti={true}
                                            isSearchable={true}
                                            onChange={this.handleExcludeChange}
                                            defaultOptions={productListDefault}
                                            loadOptions={productOptions}/>

                                    </div>
                                </div>
                                {/*<div className="form-group">*/}
                                    {/*<label className="form-label">Author</label>*/}
                                    {/*<div className="awdp_repeat_item">*/}
                                        {/*<Select*/}
                                            {/*value={this.state.rule.productAuthor}*/}
                                            {/*name={'productAuthor'}*/}
                                            {/*isMulti={true}*/}
                                            {/*isSearchable={true}*/}
                                            {/*onChange={this.handleAuthorChange}*/}
                                            {/*options={authors}/>*/}
                                    {/*</div>*/}
                                {/*</div>*/}
                            </div>
                            : // else case
                            <div className="awdp_productSelection">
                                <div className="form-group">
                                    <label className="form-label">Products</label>
                                    <div className="awdp_repeat_item">
                                        {/*<Select*/}
                                        {/*value={this.state.rule.selectedProducts}*/}
                                        {/*name={'selectedProducts'}*/}
                                        {/*isMulti={true}*/}
                                        {/*isSearchable={true}*/}
                                        {/*onChange={this.handleProductChange}*/}
                                        {/*options={options} />*/}
                                        {/* {console.log(this.state.rule.selectedProducts)} */}
                                        <AsyncSelect
                                            value={productList.filter(e => Array.isArray(this.state.rule.selectedProducts) ? this.state.rule.selectedProducts.indexOf(e.value) >= 0 : false)}
                                            name={'selectedProducts'}
                                            isMulti={true}
                                            isSearchable={true}
                                            onChange={this.handleProductChange}
                                            defaultOptions={productListDefault}
                                            loadOptions={productOptions}/>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className="save_changes list_save_changes">
                        <Button action={
                            this.openModal}
                                type={'secondary'}
                                title={'Delete'}
                                style={this.props.match.params.id == 'add' ? hideButton : buttonStyle}
                                disabled={this.state.deleteDisabled}/>
                        <Button action={
                            this.handleFormSubmit}
                                type={'primary'}
                                title={this.props.match.params.id == 'add' ? 'Publish' : 'Update'}
                                style={buttonStyle}
                                disabled={this.state.updateDisabled}/>
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Delete">
                            <h2 ref={subtitle => this.subtitle = subtitle}>All related datas will be removed.</h2>
                            <h4 ref={subtitle => this.subtitle = subtitle}>Are you sure to proceed?</h4>
                            <Button action={
                                this.closeModal}
                                    type={'primary'}
                                    title={'No'}
                                    style={buttonStyle}
                                    disabled={this.state.noDisabled}/>
                            <Button action={
                                this.handleFormDeletion}
                                    type={'secondary'}
                                    title={'Yes'}
                                    style={buttonStyle}
                                    disabled={this.state.yesDisabled}/>
                        </Modal>
                        {!this.state.isHidden && <AWRPLoader/>}
                    </div>
                </div>
            </div>
        )
    }
}